import { z } from 'zod';

export const identitySchema = z.object({
  id: z.coerce.number(),
});

export const publishedAtSchema = z.object({
  month: z.number().nullish(),
  year: z.number().min(1900),
});

export const authorSchema = z.object({
  userName: z.string().min(3).trim(),
  alias: z.string().min(6).trim(),
  membership: identitySchema,
});

export type AuthorSchema = z.infer<typeof authorSchema>;
